import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { useSnackbar } from '@lyearn/ui';

import { usePublishKnowledgeAssetMutation } from '../../CreateKnowledgeAsset/graphql/mutations/generated/publishKnowledgeAsset';

const useApproveContent = ({ contentId }: { contentId: string }) => {
  const [{ fetching }, publishKnowledgeAsset] = usePublishKnowledgeAssetMutation();
  const { showSnackbar, showErrorSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const onApprove = useCallback(() => {
    publishKnowledgeAsset({
      data: { contentId },
    })
      .then((res) => {
        if (res?.data?.publishContent?.success) {
          showSnackbar({
            message: t('Common:ApprovedSuccessfully'),
          });
        }
      })
      .catch((err) => {
        showErrorSnackbar({
          message: t('Common:SomethingWentWrong'),
        });
      });
  }, [publishKnowledgeAsset, contentId, showErrorSnackbar, showSnackbar, t]);

  return { onApprove, fetching };
};

export default useApproveContent;
